module.exports = "<div class=\"main-container\">\n  <h3 class=\"error-msg\">Your password link has expired.<br>Request a new password link.</h3>\n  <md-dialog-content>\n    <span class=\"link\"\n          (click)=\"dialog.close()\">Reset your password</span>\n  </md-dialog-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forgot-password/error-dialog/error-dialog.component.html
// module id = 180
// module chunks = 1